var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviousPageArrowPagination(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7115 12.0008L15.012 8.06892C15.3293 7.77881 15.3293 7.30846 15.012 7.01836C14.6947 6.72826 14.1803 6.72826 13.863 7.01836L8.98798 11.4755C8.67067 11.7656 8.67067 12.236 8.98798 12.5261L13.863 16.9832C14.1803 17.2733 14.6947 17.2733 15.012 16.9832C15.3293 16.6931 15.3293 16.2227 15.012 15.9326L10.7115 12.0008Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviousPageArrowPagination);
export default __webpack_public_path__ + "static/media/previous-page-arrow-pagination.ddf65f7090e1fe4cccbde4310d8a0fb2.svg";
export { ForwardRef as ReactComponent };